import { useTheme } from '@wegroup/design-system';
import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import {
  bph,
  customMediaHWQuery,
  mq,
  mqh,
} from '../../../../common/src/utils/styledComponentsUtils';
import { bp } from '../../../../design-system/src/theme/foundations/breakpoints';

// Components
import AssistantIntro from '../../assets/AssistantIntro';
import Avatar from '../default/ProdFacAvatar';

interface Props {
  isSocial?: boolean;
}

const IntroAvatar: React.FC<React.PropsWithChildren<Props>> = ({
  isSocial,
}) => {
  const { colors } = useTheme();
  const theme = useContext(ThemeContext);

  return (
    <Wrapper
      data-test-id="ProdFac_IntroContainer_IconContainer"
      isSocial={isSocial}
    >
      {!isSocial && (
        <AssistantIntro
          color={colors.primary[500]}
          secondaryColor={theme['isImmo'] ? theme.secondary[300] : undefined}
          darkColor={theme['isImmo'] ? theme.secondary[600] : undefined}
        />
      )}

      {isSocial ? (
        <StyledAvatar />
      ) : (
        <AvatarWrapper isSocial={isSocial}>
          <StyledAvatar />
        </AvatarWrapper>
      )}
    </Wrapper>
  );
};

const AvatarWrapper = styled.div<{ isSocial?: boolean }>`
  ${mqh.hd} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    ${mq.mobileM} {
      top: 70%;
    }
  }
`;

const StyledAvatar = styled(Avatar)`
  width: 10rem;
  height: 10rem;

  ${customMediaHWQuery(bp.tablet, bph.svga)} {
    width: 12rem;
    height: 12rem;
  }
`;

const Wrapper = styled.div<{ isSocial?: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10rem;

  ${mq.mobileM} {
    height: ${({ isSocial }) => (isSocial ? '10rem' : 'auto')};
  }

  ${mq.laptopL} {
    height: ${({ isSocial }) => (isSocial ? 'unset' : 'auto')};
    margin-bottom: '12px';
  }

  > svg {
    height: 100%;
    max-height: 38vh;
    width: 100%;
    display: none;

    ${customMediaHWQuery(bp.mobileM, bph.hd)} {
      display: ${({ isSocial }) => (isSocial ? 'none' : 'block')};

      ${mq.laptopL} {
        display: block;
      }
    }
  }
`;

export default IntroAvatar;
